var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0587 5.72767C18.7129 5.03453 17.6755 5.55438 18.0213 6.4208C19.4045 9.71321 18.8858 13.5255 16.4653 15.9514C14.2177 18.2041 10.9327 19.2438 7.8206 18.3774C4.70851 17.511 2.288 14.9117 1.59643 11.7926C0.904852 8.6735 1.94221 5.3811 4.53562 3.30169C7.64771 0.702421 12.1429 0.702421 15.4279 3.1284C16.1195 3.64825 16.8111 2.43526 16.1195 2.0887C12.8345 -0.51057 8.16639 -0.683854 4.70851 1.56884C1.59643 3.47497 -0.305404 7.11394 0.0403838 10.7529C0.386171 14.3919 2.63379 17.6843 6.09166 19.2438C9.54954 20.6301 13.5261 20.1103 16.4653 17.6843C19.9232 14.7385 20.9605 9.88649 19.0587 5.72767Z",
    fill: "#97BC2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37661 11.2729C7.99346 9.88658 6.43742 8.5003 5.05427 7.11403C4.36269 6.59417 3.49822 7.4606 4.1898 7.98045C5.74584 9.54001 7.47478 11.0996 9.03082 12.6591C9.20371 12.8324 9.72239 12.8324 9.89529 12.6591C12.6616 9.88658 15.4279 7.11403 18.1942 4.16819C18.54 3.82162 19.0587 3.47505 19.4044 3.12849C19.9231 2.60863 19.0587 1.56893 18.54 2.26206C15.6008 4.86133 12.8345 7.80716 10.0682 10.5797C9.89529 10.753 9.5495 11.0996 9.37661 11.2729Z",
    fill: "#97BC2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSuccess);
export default __webpack_public_path__ + "static/media/list_success.615d1e1745393c062f5b10cb56afa921.svg";
export { ForwardRef as ReactComponent };